import { withBoxComponent, LINK } from '../../../../components/box-component/with-box-component.desktop';
import OnlineRentalDetails from '../../../../components/online-rental-details';
import enhance from './online-rental-details';

const OnlineRentalDetailsDesktop = withBoxComponent({ type: LINK })(OnlineRentalDetails);

export default enhance(OnlineRentalDetailsDesktop);
